import Axios from 'axios';

import {
	HELPER_INSTANCE_INFO_LOADING,
	HELPER_INSTANCE_INFO_GET,
	HELPER_INSTANCE_INFO_ERROR,
	HELPER_INSTANCE_DATA_GET,
	HELPER_INSTANCE_DATA_ERROR,
	HELPER_INSTANCE_DATA_HISTORY_GET,
	HELPER_INSTANCE_DATA_HISTORY_ERROR,
	HELPER_INSTANCE_CONFIG_GET,
	HELPER_INSTANCE_CONFIG_ERROR,
	HELPER_INSTANCE_START_ERROR,
	HELPER_INSTANCE_STOP_ERROR,
	HELPER_INSTANCE_END_ERROR,
	HELPER_INSTANCE_CLEAN_ERROR,
	HELPER_INSTANCE_STATUS_HISTORY_GET,
	HELPER_INSTANCE_STATUS_HISTORY_ERROR,
	HELPER_INSTANCE_COMMANDS_LOADING,
	HELPER_INSTANCE_COMMANDS_GET,
	HELPER_INSTANCE_COMMANDS_ERROR
} from './types';

// Actions
import { alert_remove, alert_set } from './alertActions';
import { get_jobs_failed, get_jobs_history, get_jobs_waiting, get_job_current, get_job_last } from './jobsActions';

// Utils
import create_query_params from '../utils/create_query_params';

export const helper_instance_loading_true = () => dispatch => {
	dispatch({
		type: HELPER_INSTANCE_INFO_LOADING,
		payload: true
	});
}

export const helper_instance_loading_false = () => dispatch => {
	dispatch({
		type: HELPER_INSTANCE_INFO_LOADING,
		payload: false
	});
}

export const get_helper_instance_info = (instance_id) => dispatch => {
	// console.log(instance_id)
	dispatch(helper_instance_loading_true());

	let url = process.env.REACT_APP_SERVER_URL + `/api/controller/helpers/${instance_id}/state`;

	Axios.get(url)
	.then((res) => {
		// console.log(res.data)
		dispatch({
			type: HELPER_INSTANCE_INFO_GET,
			payload: res.data
		});

		dispatch(helper_instance_loading_false());
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: HELPER_INSTANCE_INFO_ERROR,
			payload: { type: 'helper_instance_info', msg: err.message }
		});

		dispatch(helper_instance_loading_false());
	})
}

export const get_helper_instance_data = (instance_id) => dispatch => {
	// console.log(instance_id)
	dispatch(helper_instance_loading_true());

	let url = process.env.REACT_APP_SERVER_URL + `/api/controller/helpers/${instance_id}/data`;

	Axios.get(url)
	.then((res) => {
		// console.log(res.data)
		dispatch({
			type: HELPER_INSTANCE_DATA_GET,
			payload: typeof res.data === 'string' ? JSON.parse(res.data) : res.data
		});
		dispatch(helper_instance_loading_false());
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: HELPER_INSTANCE_DATA_ERROR,
			payload: { type: 'helper_instance_data', msg: err.message }
		});
		dispatch(helper_instance_loading_false());
	})
}

export const get_helper_instance_data_history = (instance_id, skip, limit) => dispatch => {
	// console.log(instance_id)

	let url = process.env.REACT_APP_SERVER_URL + `/api/controller/helpers/${instance_id}/data/history?skip=${skip}&limit=${limit}`;

	Axios.get(url)
	.then((res) => {
		// console.log(res.data)
		dispatch({
			type: HELPER_INSTANCE_DATA_HISTORY_GET,
			payload: res.data
		});
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: HELPER_INSTANCE_DATA_HISTORY_ERROR,
			payload: { type: 'helper_instance_data_history', msg: err.message }
		});
	})
}

export const get_helper_instance_config = (instance_id) => dispatch => {
	// console.log(instance_id)
	let url = process.env.REACT_APP_SERVER_URL + `/api/controller/helpers/${instance_id}/configuration`;

	Axios.get(url)
	.then((res) => {
		// console.log(res.data)
		dispatch({
			type: HELPER_INSTANCE_CONFIG_GET,
			payload: res.data
		});
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: HELPER_INSTANCE_CONFIG_ERROR,
			payload: { type: 'helper_instance_config', msg: err.message }
		});
	})
}

export const helper_instance_start = (instance_id) => dispatch => {
	// console.log(instance_id)
	dispatch(helper_instance_loading_true());

	let url = process.env.REACT_APP_SERVER_URL + `/api/controller/helpers/${instance_id}/start`;

	Axios.get(url)
	.then((res) => {
		// console.log(res.data)
		dispatch(alert_set('#198754', 'success', 'Helper instance started successfully.'));

		setTimeout(() => {
			dispatch(alert_remove());
		}, 4000);

		dispatch(helper_instance_loading_false());
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: HELPER_INSTANCE_START_ERROR,
			payload: { type: 'helper_instance_start', msg: err.message }
		});
		dispatch(helper_instance_loading_false());
	})
}

export const helper_instance_stop = (instance_id) => dispatch => {
	// console.log(instance_id)
	dispatch(helper_instance_loading_true());

	let url = process.env.REACT_APP_SERVER_URL + `/api/controller/helpers/${instance_id}/stop`;

	Axios.get(url)
	.then((res) => {
		// console.log(res.data)
		dispatch(alert_set('#0d6efd', 'success', 'Helper instance stopped successfully.'));
		setTimeout(() => {
			dispatch(alert_remove());
		}, 4000);

		dispatch(helper_instance_loading_false());
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: HELPER_INSTANCE_STOP_ERROR,
			payload: { type: 'helper_instance_stop', msg: err.message }
		});
		dispatch(helper_instance_loading_false());
	})
}

export const helper_instance_end = (instance_id) => dispatch => {
	// console.log(instance_id)
	dispatch(helper_instance_loading_true());

	let url = process.env.REACT_APP_SERVER_URL + `/api/controller/helpers/${instance_id}/end`;

	Axios.get(url)
	.then((res) => {
		// console.log(res.data)
		dispatch(alert_set('#dc3545', 'success', 'Helper instance ended successfully.'));
		setTimeout(() => {
			dispatch(alert_remove());
		}, 4000);

		dispatch(helper_instance_loading_false());
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: HELPER_INSTANCE_END_ERROR,
			payload: { type: 'helper_instance_end', msg: err.message }
		});
		dispatch(helper_instance_loading_false());
	})
}

export const helper_instance_clean = (instance_id, reqBody, closeModalRef) => dispatch => {
	// console.log(instance_id)
	let url = process.env.REACT_APP_SERVER_URL + `/api/controller/helpers/${instance_id}/clean`;

	Axios.delete(url, { data: reqBody })
	.then((res) => {
		// console.log(res.data)
		dispatch(alert_set('#fd7e14', 'success', 'Helper instance cleaned successfully.'));
		setTimeout(() => {
			dispatch(alert_remove());
		}, 4000);

		setTimeout(() => {
			closeModalRef.current.click();
			dispatch(get_job_current('helpers', instance_id));
			dispatch(get_job_last('helpers', instance_id));
			dispatch(get_jobs_history('helpers', instance_id, -10, -1));
			dispatch(get_jobs_failed('helpers', instance_id, -10, -1));
		}, 1000);
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: HELPER_INSTANCE_CLEAN_ERROR,
			payload: { type: 'helper_instance_clean', msg: err.message }
		});
	})
}

export const get_helper_instance_status_history = (instance_id, skip, limit) => dispatch => {
	// console.log(instance_id)
	let url = process.env.REACT_APP_SERVER_URL + `/api/resources/helpers/instances/${instance_id}/history?skip=${skip}&limit=${limit}`;

	Axios.get(url)
	.then((res) => {
		// console.log(res.data)
		dispatch({
			type: HELPER_INSTANCE_STATUS_HISTORY_GET,
			payload: res.data
		});
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: HELPER_INSTANCE_STATUS_HISTORY_ERROR,
			payload: { type: 'helper_instance_status_history', msg: err.message }
		});
	})
}

export const get_helper_instance_commands = (instance_id, filters) => dispatch => {
	dispatch({
		type: HELPER_INSTANCE_COMMANDS_LOADING,
		payload: true
	});

	let url = process.env.REACT_APP_SERVER_URL + `/api/controller/helpers/${instance_id}/commands?`;
	let query = create_query_params(filters);
	url += query;

	Axios.get(url)
	.then((res) => {
		// console.log(res.data)
		dispatch({
			type: HELPER_INSTANCE_COMMANDS_GET,
			payload: res.data
		});

		dispatch({
			type: HELPER_INSTANCE_COMMANDS_LOADING,
			payload: false
		});
	}).catch((err) => {
		// console.log(err);
		dispatch({
			type: HELPER_INSTANCE_COMMANDS_ERROR,
			payload: { type: 'helper_instance_commands', msg: err.message }
		});

		dispatch({
			type: HELPER_INSTANCE_COMMANDS_LOADING,
			payload: false
		});
	})
}
